document.addEventListener('DOMContentLoaded', function () {
  const filterForm = document.querySelector('.collection-filter__scrollable');
  if (!filterForm) return;

  const overlay = document.createElement('div');
  overlay.className = 'collection-filter-overlay';

  const drawer = document.createElement('div');
  drawer.className = 'collection-filter-drawer';
  drawer.innerHTML = `
    <div class="collection-filter-drawer__header">
      <h3>Filters</h3>
      <button class="collection-filter-drawer__close" aria-label="Kapat">&#x2715;</button>
    </div>
    <div class="collection-filter-drawer__body"></div>
    <div class="collection-filter-drawer__footer">
      <button class="collection-filter-drawer__clear">Clear</button>
      <button class="collection-filter-drawer__apply">Apply</button>
    </div>
  `;

  const toggle = document.createElement('button');
  toggle.className = 'collection-filter-toggle';
  toggle.innerHTML = '&#9776; Filter';

  const drawerBody = drawer.querySelector('.collection-filter-drawer__body');
  drawerBody.appendChild(filterForm);

  const filterWrapper = document.querySelector('.collection-filter__wrapper');
  if (filterWrapper) {
    filterWrapper.insertBefore(toggle, filterWrapper.firstChild);
  }

  document.body.appendChild(overlay);
  document.body.appendChild(drawer);

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    drawer.querySelectorAll('.collection-filter__group').forEach(function(group) {
      const title = group.querySelector('.collection-filter__title');
      if (!title || title._accordionBound) return;
      title._accordionBound = true;
      title.addEventListener('click', function() {
        group.classList.toggle('is-open');
      });
    });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openDrawer);
  overlay.addEventListener('click', closeDrawer);
  drawer.querySelector('.collection-filter-drawer__close').addEventListener('click', closeDrawer);

  drawer.querySelector('.collection-filter-drawer__apply').addEventListener('click', function () {
    filterForm.submit();
  });

  drawer.querySelector('.collection-filter-drawer__clear').addEventListener('click', function () {
    const url = new URL(window.location.href);
    url.searchParams.forEach((_, key) => {
      if (key.startsWith('filter.')) url.searchParams.delete(key);
    });
    window.location.href = url.toString();
  });

});
